module.exports = __webpack_public_path__ + "img/01-accessibility-convenience.9a4bb5e9.png";